import {EditorSelection} from "@codemirror/state";

import {isCursorInInlineSpace, isInlineSpace} from "../state.js";
import {changeByTrimmedRange} from "./ranges.js";
import {quotePadding} from "./padding.js";
import {simplePut} from "./changes.js";
import {image} from "../markdown.js";

export function insertImage(alt, imageHref) {
  return ({state, dispatch}) => {
    if (isCursorInInlineSpace(state)) {
      simplePut(state, dispatch, image(alt, encodeURI(imageHref)));
    }
  };
}

export function addImage(hrefPlaceholder) {
  return ({state, dispatch}) => {
    if (canAddImage({state})) {
      dispatch({
        ...addImageCommand(state, encodeURI(hrefPlaceholder)),
        userEvent: "input.addImage",
      });
    }
  };
}

export function canAddImage({state}) {
  return isInlineSpace(state);
}

function addImageCommand(state, href) {
  return changeByTrimmedRange(state, ({from, to}) => {
    const markdownPrefix = quotePadding(state, from) + '![image](';
    return {
      changes: {from, to, insert: markdownPrefix + href + ')'},
      range: EditorSelection.range(from + markdownPrefix.length, from + markdownPrefix.length + href.length)
    };
  });
}
